import { render, staticRenderFns } from "./MinLengthErrorMessage.vue?vue&type=template&id=ebdbdd56&"
import script from "./MinLengthErrorMessage.vue?vue&type=script&lang=js&"
export * from "./MinLengthErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebdbdd56')) {
      api.createRecord('ebdbdd56', component.options)
    } else {
      api.reload('ebdbdd56', component.options)
    }
    module.hot.accept("./MinLengthErrorMessage.vue?vue&type=template&id=ebdbdd56&", function () {
      api.rerender('ebdbdd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Errors/MinLengthErrorMessage.vue"
export default component.exports